<template>
  <el-dialog title="添加情景练习题目" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form class="el-cus" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="添加题目：" prop="name" class="width100">
        <el-select v-model="value" multiple filterable remote reserve-keyword placeholder="请输入关键词" :popper-append-to-body="false" :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="item in exerciseOptions" :key="item.id" :label="item.questionContent" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import courseScenarioExerciseApi from '@/api/course/courseScenarioExercise'


export default {
  data() {
    return {
      value: '',
      formVisible: false,
      exerciseOptions: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(query, type) {
      courseScenarioExerciseApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1, questionContent: query }).then(({ data }) => {
        this.exerciseOptions = data.list
        if (type) this.formVisible = true
      })
    },
    handleSubject() {
      this.value = ''
      this.getList("", 1)
    },
    remoteMethod(query) {
      this.getList(query)
    },
    doCreate() {
      if (!this.value) return this.$message.error('请选择题目')
      let arr = []
      this.value.forEach(item => {
        let find = this.exerciseOptions.find(itt => itt.id === item)
        if (find) arr.push(find)
      })
      this.$emit('created', arr)
      this.formVisible = false
    },
  }
}
</script>
<style lang="scss" scoped>
.el-cus {
  padding: 0 15px;
}
::v-deep .el-select-dropdown.el-popper {
  max-width: 600px !important;
}
</style>
